import { SecurityContext } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

/**
 * Sanitizes HTML for safe binding to `innerHTML` (strips scripts and other unsafe content).
 * Intended for admin-authored content where the source is trusted but defense-in-depth is still desired.
 *
 * Callers must inject {@link DomSanitizer} and pass it in. If this pattern spreads to
 * multiple components, consider a shared pipe or injectable service to centralize DI.
 */
export function sanitizeTrustedHtml(
    sanitizer: DomSanitizer,
    html: string
): string {
    return sanitizer.sanitize(SecurityContext.HTML, html) ?? '';
}
